import { createApp } from 'vue'
import { Amplify } from 'aws-amplify'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import './style.css'
import './styles/index.css'
import outputs from '../amplify_outputs.json'

// Configure Amplify with platform-aware OAuth settings
// Use dynamic import for Capacitor to avoid bundling in web builds
const initializeAmplify = async () => {
  // Check if running in a Capacitor native context
  // This check happens at runtime and won't bundle Capacitor for web
  if (window.Capacitor?.isNativePlatform?.()) {
    try {
      const { Capacitor } = await import('@capacitor/core')
      const { App: CapApp } = await import('@capacitor/app')

      if (Capacitor.isNativePlatform() && outputs.auth?.oauth) {
        // Mobile: Use custom URL scheme for OAuth redirects
        Amplify.configure({
          ...outputs,
          Auth: {
            ...outputs.Auth,
            oauth: {
              ...outputs.auth.oauth,
              redirectSignIn: 'socialhood://oauth/',
              redirectSignOut: 'socialhood://oauth/signout',
            }
          }
        })

        // Handle deep links for OAuth callbacks
        CapApp.addListener('appUrlOpen', (event) => {
          console.log('Deep link received:', event.url)

          // Amplify will automatically handle OAuth callback URLs
          // that match the configured redirect patterns
          if (event.url.includes('oauth')) {
            // Let Amplify SDK handle the OAuth callback
            window.location.href = event.url
          }
        })
        return
      }
    } catch (error) {
      console.warn('Capacitor not available:', error)
    }
  }

  // Web: Use standard configuration
  Amplify.configure(outputs)
}

// Initialize Amplify and mount app (wrapped to avoid top-level await)
;(async () => {
  await initializeAmplify()

  const app = createApp(App)
  const head = createHead()

  // Global error handler for Vue application errors
  app.config.errorHandler = (error, instance, info) => {
    console.error('Vue Global Error:', error)
    console.error('Component:', instance)
    console.error('Error Info:', info)

    // TODO: Report to error logging service
    // Example: Sentry.captureException(error)
  }

  // Handle warnings in development
  if (import.meta.env.DEV) {
    app.config.warnHandler = (msg, instance, trace) => {
      console.warn('Vue Warning:', msg)
      console.warn('Trace:', trace)
    }
  }

  app.use(router).use(head).mount('#app')

  // Remove loading class for smooth fade-in after Vue mounts
  document.getElementById('app').classList.remove('loading')
})()